/**
 * Normalizes a user-typed memory file name into a proper memory-store path.
 * Non-technical users will type something like "test-agent-memory" — this
 * adds the leading slash and a default .md extension so it becomes a valid
 * path (e.g. "/test-agent-memory.md") without them needing to know the
 * memory store's path conventions.
 */
export function normalizeMemoryPath(raw: string): string {
    let path = raw.trim();
    if (!path) return '';
    path = path.replace(/\s+/g, '-');
    if (!path.startsWith('/')) path = '/' + path;
    if (!/\.[a-zA-Z0-9]+$/.test(path)) path += '.md';
    return path;
}
